"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToFrame = sendMessageToFrame;
exports.broadcastMessage = broadcastMessage;
exports.executeSubscriptions = executeSubscriptions;
var tslib_1 = require("tslib");
function sendMessageToFrame(_a) {
    var _b;
    var payload = _a.payload, type = _a.type, frameId = _a.frameId, frame = _a.frame;
    (_b = frame.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({ type: type, payload: payload, frameId: frameId }, "*");
}
function broadcastMessage(_a) {
    var frames = _a.frames, props = tslib_1.__rest(_a, ["frames"]);
    Object.values(frames).forEach(function (frame) { return sendMessageToFrame(tslib_1.__assign(tslib_1.__assign({}, props), { frame: frame })); });
}
function executeSubscriptions(_a) {
    var events = _a.events, subscriptions = _a.subscriptions, payload = _a.payload;
    subscriptions.forEach(function (subscription) {
        if (!events.includes(subscription.event))
            return;
        subscription.callback(payload);
    });
}
